const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <h4 className="text-lg font-medium pb-2">{children}</h4>
)

export default FieldLabel
